module.exports = __webpack_public_path__ + "static/media/gallery-plan.109807c3.svg";